/*
 * Psydeck menu search: live results from Shopify's /search/suggest.json.
 * Matching collections (sets, product types) come first, then compact product
 * rows with price and a sold-out badge (sold-out last). Same query and layout
 * as the mobile menu's search panel (assets/psydeck-mobile-menu.js).
 *
 * PsydeckMenuSearch.attach({ root, input, empty, results, all, clear, prefix, onRender })
 * - root: element with data-root, data-currency, data-money-format, data-locale, data-max-collections
 * - prefix: class prefix for the result markup, e.g. 'psy-ds'
 * Returns { run(now) }: run(true) searches without the typing delay.
 */
(function () {
  if (window.PsydeckMenuSearch) return;

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function thumb(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  // Shopify's money format (shop.money_format, e.g. "€{{amount_with_comma_separator}}"),
  // so prices match the ones Liquid prints. Falls back to Intl when it is missing.
  function formatMoney(amount, format, fallback) {
    if (!format) return fallback.format(amount);
    var cents = Math.round(Number(amount) * 100);
    function delimit(n, decimals, thousands, decimal) {
      var parts = (n / 100).toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }
    var out = format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount_no_decimals': return delimit(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return delimit(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delimit(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delimit(cents, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return delimit(cents, 0, ' ', ',');
        case 'amount_with_space_separator': return delimit(cents, 2, ' ', ',');
        case 'amount_with_period_and_space_separator': return delimit(cents, 2, ' ', '.');
        default: return delimit(cents, 2, ',', '.');
      }
    });
    return out.replace(/<[^>]*>/g, '');
  }

  var CHEV = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#5F8AB5" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';

  function attach(o) {
    var root = o.root, input = o.input, x = o.prefix;
    var isPt = root.dataset.locale === 'pt-PT';
    var intl = new Intl.NumberFormat(isPt ? 'pt-PT' : 'en', { style: 'currency', currency: root.dataset.currency || 'EUR' });
    var moneyFormat = root.dataset.moneyFormat;
    var maxCollections = parseInt(root.dataset.maxCollections, 10);
    if (isNaN(maxCollections)) maxCollections = 2;
    var searchUrl = input.form ? input.form.getAttribute('action') : '/search';
    var timer = null;
    var ctrl = null;

    function render(q, res) {
      var products = (res && res.products) || [];
      var collections = (res && res.collections) || [];
      var html = '';
      if (collections.length && maxCollections > 0) {
        html += '<div class="' + x + '__kicker">' + (isPt ? 'Coleções' : 'Collections') + '</div><ul class="' + x + '__scols" role="list">';
        collections.slice(0, maxCollections).forEach(function (c) {
          var img = c.featured_image && c.featured_image.url;
          html += '<li><a class="' + x + '__scol" href="' + esc(c.url) + '">' +
            '<span class="' + x + '__scol-img">' + (img ? '<img src="' + esc(thumb(img, 160)) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="' + x + '__scol-title">' + esc(c.title) + '</span>' + CHEV + '</a></li>';
        });
        html += '</ul>';
      }
      if (products.length) {
        html += '<div class="' + x + '__kicker">' + (isPt ? 'Produtos' : 'Products') + '</div><ul class="' + x + '__sprods" role="list">';
        products.forEach(function (p) {
          var img = p.featured_image && p.featured_image.url || p.image;
          var price = Number(p.price);
          var badge = p.available === false ? '<span class="' + x + '__sbadge">' + (isPt ? 'Esgotado' : 'Sold out') + '</span>' : '';
          html += '<li><a class="' + x + '__sprod" href="' + esc(p.url) + '">' +
            '<span class="' + x + '__sprod-img">' + (img ? '<img src="' + esc(thumb(img, 144)) + '" alt="" loading="lazy">' : '') + '</span>' +
            '<span class="' + x + '__sprod-body"><span class="' + x + '__sprod-title">' + esc(p.title) + '</span>' +
            '<span class="' + x + '__sprod-meta">' + (isNaN(price) ? '' : '<span class="' + x + '__sprod-price">' + formatMoney(price, moneyFormat, intl) + '</span>') + badge + '</span></span></a></li>';
        });
        html += '</ul>';
      }
      var none = !html;
      if (none) {
        html = '<p class="' + x + '__snone">' + (isPt ? 'Sem resultados para' : 'No results for') + ' “' + esc(q) + '”.</p>';
      }
      o.results.innerHTML = html;
      o.results.hidden = false;
      // No results: keep the popular searches and latest sets below the message.
      o.empty.hidden = !none;
      o.all.hidden = !products.length;
      // Same settings as the search page (snippets/psydeck-search-page.liquid), so it needn't redirect.
      o.all.href = searchUrl + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last' +
        '&options%5Bfields%5D=title,product_type,variants.title,variants.sku,vendor,tag&options%5Bunavailable_products%5D=last';
      if (o.onRender) o.onRender();
    }

    function run(now) {
      var q = input.value.trim();
      if (o.clear) o.clear.hidden = !input.value;
      clearTimeout(timer);
      if (ctrl) ctrl.abort();
      if (!q) {
        o.results.hidden = true;
        o.results.innerHTML = '';
        o.empty.hidden = false;
        o.all.hidden = true;
        if (o.onRender) o.onRender();
        return;
      }
      timer = setTimeout(function () {
        ctrl = window.AbortController ? new AbortController() : null;
        var params = 'q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection&resources[limit]=10&resources[limit_scope]=each' +
          '&resources[options][prefix]=last&resources[options][unavailable_products]=last' +
          '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor,tag';
        fetch((root.dataset.root || '/').replace(/\/$/, '') + '/search/suggest.json?' + params, ctrl ? { signal: ctrl.signal } : {})
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (input.value.trim() !== q) return;
            render(q, data && data.resources && data.resources.results);
          })
          .catch(function () {});
      }, now === true ? 0 : 180);
    }

    input.addEventListener('input', run);
    return { run: run };
  }

  window.PsydeckMenuSearch = { attach: attach };
})();
